// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pW501","contactContainer":"styles_contactContainer__2b8p1","svgContainer":"styles_svgContainer__084FT","special":"styles_special__khyQd"};